/* Copyright (c) 2020-present CloudIO Inc */

import { emptyFunction } from '@cloudio-saas/statex';
import { useRef } from 'react';
import { startPageProgress } from '../components/Page/PageProgressed';

const map = new Map<string, { loaded: boolean; error: boolean }>();

export function clearImageCache() {
  map.clear();
}

export function useImageLoaded(
  appUid: string,
  pageId: string,
  src?: string | null,
) {
  const loaded = useRef(false);
  // const
  if (!src || loaded.current) return;
  let end = emptyFunction;
  if (!map.has(src)) {
    end = startPageProgress(appUid, pageId, src);
  } else {
    return;
  }
  loaded.current = true;
  map.set(src, { loaded: false, error: false });
  const image = new Image();
  image.addEventListener('load', () => {
    map.set(src, { loaded: true, error: false });
    setTimeout(() => {
      end();
    }, 300);
  });
  image.addEventListener('error', () => {
    map.set(src, { loaded: false, error: true });
    end();
  });
  image.src = src;
}
